import { LoaderFunctionArgs, redirect } from "react-router-dom";
import { recipesService } from "../../../services/recipes.service";
import { ingredientService } from "../../../services/ingredients.service";

export async function editProductLoader({ params }: LoaderFunctionArgs) {
    const id = params.id;
    if (!id) {
        return redirect('/productos');
    }
    const urlParams = new URLSearchParams(document.location.search);

    const [product, ingredients] = await Promise.all([
        recipesService.getById(id),
        await ingredientService.get(urlParams.has('refresh')),
    ]);

    return { product, ingredients };
}